import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  ConfirmExternalFlightBookingDetailsErrorResponse,
  ConfirmExternalFlightBookingDetailsRequest,
  ConfirmExternalFlightBookingDetailsSuccessResponse
} from './confirmExternalFlightBookingDetails.types'

export const confirmExternalFlightBookingDetailsApi = async (
  request: ConfirmExternalFlightBookingDetailsRequest
): Promise<ConfirmExternalFlightBookingDetailsSuccessResponse> => {
  const response = await configureRequest({
    url: urls.flights.confirmExternalFlightBookingDetails,
    method: 'POST',
    data: request,
    params: {},
    headers: {
      'X-User-Role': UserRole.traveler
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as ConfirmExternalFlightBookingDetailsSuccessResponse
  } else {
    throw response as ConfirmExternalFlightBookingDetailsErrorResponse
  }
}

export default confirmExternalFlightBookingDetailsApi
